import { render, staticRenderFns } from "./newtopbar.vue?vue&type=template&id=66ffb421&"
import script from "./newtopbar.vue?vue&type=script&lang=js&"
export * from "./newtopbar.vue?vue&type=script&lang=js&"
import style0 from "./newtopbar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports